export * from './weather-condition-component-config.interface';
export * from './weather-condition-content.interface';
